module.exports = __webpack_public_path__ + "static/close-icon-black.b89e3347.svg";